let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dMzCd")).then(() => parcelRequire('2DHRc'));